import { create } from 'zustand';

/**
 * Which course (and item within it) the student is currently in — the "where
 * am I going" context that drives the Learning Shell's course-outline drawer
 * (components/LearningShell/CourseOutlineDrawer, see docs/ide-ux-spec.md §16.1).
 *
 * Course/item pages publish this on mount and clear it on unmount. When
 * `courseSlug` is null (e.g. on the dashboard) the drawer hides itself — there
 * is no outline to show. Kept separate from companionStore so the left rail
 * (navigation) and right rail (tutor) stay independent.
 */
interface CourseNavState {
  courseSlug: string | null;
  /** The item open within the course, highlighted in the outline. */
  activeItemId: string | null;
  isOpen: boolean;

  setContext: (courseSlug: string | null, activeItemId?: string | null) => void;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useCourseNavStore = create<CourseNavState>((set) => ({
  courseSlug: null,
  activeItemId: null,
  isOpen: false,

  setContext: (courseSlug, activeItemId = null) => set({ courseSlug, activeItemId }),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));
